import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { DASHBOARD_ROUTES } from "app/dashboard/dashboard.routing";
import { DashboardService } from 'app/dashboard/services/dashboard.service';
import { DashboardComponent } from 'app/dashboard/component/dashboard/dashboard.component';
import { UserDashboardComponent } from 'app/dashboard/component/user-dashboard/user-dashboard.component';
import { LenderDashboardComponent } from 'app/dashboard/component/lender-dashboard/lender-dashboard.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
	imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(DASHBOARD_ROUTES)
	],
    declarations: [
        DashboardComponent,
        UserDashboardComponent,
        LenderDashboardComponent
    ],
	providers: [DashboardService]
})
export class DashboardModule { }
